import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    ClientName: {
      validations: []
    },
    FirstName: {
      validations: []
    },
    LastName: {
      validations: []
    },
    AddressLine1: {
      validations: []
    },
    City: {
      validations: []
    },
    State: {
      validations: []
    },
    Postal: {
      validations: [
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    PlannedGuestCount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'}
      ]
    },
    Description: {
      validations: []
    },
    SiteName: {
      validations: []
    },
    EventExtra3: {
      validations: []
    },
    EventExtra1: {
      validations: []
    },
    EventExtra4: {
      validations: []
    },
    Notes: {
      validations: []
    },
    Comments: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'CONTACT INFO',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Client/Organization: ',
            mapping: 'ClientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Contact Person (If different than client/organization):',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:',
            mapping: 'FirstName'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Last Name',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Street Address:',
            mapping: 'AddressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'City'
      },
      {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'State'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Zip Code:',
            mapping: 'Postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone:',
            mapping: 'TelNumber'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Email:',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Event Info:',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'EventDate'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Planned Number of Guests:',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type:',
            options:[
              {label: 'Anniversary/Birthday' , value: 'Anniversary/Birthday'},
              {label: 'Corporate' , value: 'Corporate'},
              {label: 'Funeral/Memorial' , value: 'Funeral/Memorial'},
              {label: 'Wedding' , value: 'Wedding'},
              {label: 'Other' , value: 'Other'},
            ],
            mapping: 'Description'
      },
      {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Location:',
            options:[
              {label: '7 Vines Vineyard' , value: '7 Vines Vineyard'},
              {label: 'Charleston Event Center' , value: 'Charleston Event Center'},
              {label: 'Kellerman\'s Event Center' , value: 'Kellerman\'s Event Center'},
              {label: 'North Heights Lutheran Church, Arden Hills' , value: 'North Heights Lutheran Church, Arden Hills'},
              {label: 'North Heights Lutheran Church, Roseville' , value: 'North Heights Lutheran Church, Roseville'},
              {label: 'Tanners Brook Golf Course' , value: 'Tanners Brook Golf Course'},
              {label: 'Vadnais Heights Commons' , value: 'Vadnais Heights Commons'},
              {label: 'Private Home' , value: 'Private Home'},
              {label: 'Other' , value: 'Other'},
            ],
            mapping: 'SiteName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Service:',
            options: [
              { label: 'Delivery Only', value: 'Delivery Only' },
              { label: 'Full, Staffed Service', value: 'Full, Staffed Service' },
              { label: 'Pick-Up in Little Canada', value: 'Pick-Up in Little Canada' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'EventExtra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Type of Meal Desired:',
            options: [
              { label: 'Breakfast', value: 'Breakfast' },
              { label: 'Appetizers & Hor D\'oeuvres', value: 'Appetizers & Hor D\'oeuvres' },
              { label: 'Soup, Sandwiches & Salads', value: 'Soup, Sandwiches & Salads' },
              { label: 'Hot Buffet', value: 'Hot Buffet' },
              { label: 'Hot Plated', value: 'Hot Plated' },
              { label: 'Picnic Buffet', value: 'Picnic Buffet' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'EventExtra1',
            customClasses: ['check-columns']
      },
      {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'Amenities Desired:',
            options: [
              { label: 'China Plates' , value: 'China Plates'},
              { label: 'Water Glasses', value: 'Water Glasses'},
              { label: 'Table Linens', value: 'Table Linens'},
              { label: 'Line Napkins', value: 'Line Napkins' },
              { label: 'Coffee Cups' , value: 'Coffee Cups'},
              { label: 'Champagne Glasses', value: 'Champagne Glasses'},
              { label: 'Wine Glasses', value: 'Wine Glasses'},
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'EventExtra4',
            customClasses: ['check-columns']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Entrees Desired:',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Additional Comments/Questions:',
            mapping: 'Comments'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Creative Catering LLC by Molly Contact Form',
    formId: '661',
    clientKey: '69B768B2-20D8-4F91-A545-5E735D2E3230',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
